"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockNutrition = void 0;
var mockNutrition = {
  individualNutritionItems: [{
    additionalDescriptions: null,
    allergen: 'This product contains milk, wheat, and soy.',
    calories: '2100',
    description: 'A large buttery-flavored soft pretzel crust pizza with pizza sauce.',
    menuItemCode: 'HNR-SPCPS',
    name: 'Pretzel Crust with Pizza Sauce',
    nutritionDetails: [{
      label: 'Calories',
      value: '2100'
    }, {
      label: 'Calories From Fat',
      value: '770'
    }, {
      label: 'Fat (g)',
      value: '87'
    }, {
      label: 'Saturated Fat (g)',
      value: '35'
    }, {
      label: 'Trans Fat (g)',
      value: '2'
    }, {
      label: 'Cholesterol (mg)',
      value: '175'
    }, {
      label: 'Sodium (mg)',
      value: '10540'
    }, {
      label: 'Carbs (g)',
      value: '241'
    }, {
      label: 'Fiber (g)',
      value: '11'
    }, {
      label: 'Sugars (g)',
      value: '12'
    }, {
      label: 'Protein (g)',
      value: '92'
    }],
    servingSize: '1 Pizza, Serving size: 1/8 Pizza'
  }],
  nutritionKey: 'HNR-SPCPS',
  succeeded: true
};
exports.mockNutrition = mockNutrition;